import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { Constant, UpdateStatus } from "../../constants";
import { ProgressBarComponent } from "../../components";

const ActivatePage = () => {
    const {state} = useLocation()

    const [loadingProgress, setLoadingProgress] = useState(0)
    const [loadingMessage] = useState("Mise à jour en cours...")

    useEffect(() => {
        const timer = setInterval(() => {
            setLoadingProgress((prevProgress) => prevProgress + 10);
        }, 800);
        return () => {
            clearInterval(timer);
        };
    }, []);

    useEffect(() => {
        if(loadingProgress === 100){
            window.localStorage.setItem(Constant.localStorageKey.updateDone, true)
            UpdateStatus.setUpdateStatus(true)
            window.location.replace(process.env.PUBLIC_URL.length === 0 ? "/" : process.env.PUBLIC_URL); 
        }
    }, [loadingProgress])

    return <div className={`page ${state && state.prev ? "page--prev" : ""}`}>
        <div className="form-group">
            <h1>Mise à jour de l'application</h1>
            <ProgressBarComponent value={loadingProgress} message={loadingMessage} />
        </div>
    </div>
}

export default ActivatePage;